import './popinSurroundings.css';

const sliderPhotosModule = () => import(/* webpackChunkName: 'components/sliderPhotos' */'../../sliderPhotos/sliderPhotos');

import { popinSurroundingsTpl } from './popinSurroundingsTpl';

let fancyCloseType = 'implicit',
  fancyboxOptions = {
    topRatio: 0.5,
    fitToView: true,
    padding: 0,
    touch: false,
    baseClass: 'popinSurroundings-fancybox',
    afterClose: () => {
      //handling close tracking
      Tracking.dataLayerPush({
        clickCode: 'clickPopinExit',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'SurroundingsDetails',
        gaLabel: fancyCloseType,
        gaValue: 1,
        event: 'clickEvent'
      });
      fancyCloseType = 'Implicit';
    },
    afterShow: () => {
      //specify trackingCloseType on click on close button
      $('.fancybox-close-small').on('click', () => {
        fancyCloseType = 'Explicit';
      });
    }
  };

export const popinSurroundings = {
  cacheDataPopin: [],
  getElementByOwnerCode: (ownerCode) => {
    return this.cacheDataPopin.find((item) => item.ownerCode === ownerCode) || null;
  },

  getNextAndPrevPoi: (pois, currentIndex) => {
    const prevPoi = currentIndex > 0 ? pois[currentIndex - 1].owenerCode : null;
    const nextPoi = currentIndex < pois.length - 1 ? pois[currentIndex + 1].owenerCode : null;

    return {
      prevPoi,
      nextPoi
    };
  },

  init: function () {
    $(document).on('click', '.js-domainSurroundingsPopin, .popinSurroundings-arrow', (event) => {
      event.preventDefault();
      const dataCode = $(event.currentTarget).attr('data-code');
      const $vignetTarget = $('.js-domainSurroundingsPopin[data-code="'+dataCode+'"]');
      const dataNextCode =  $vignetTarget.next().length ? $vignetTarget.next().attr('data-code') : false;
      const dataPrevCode = $vignetTarget.prev().length ? $vignetTarget.prev().attr('data-code') : false;

      const successCallback = () => {
        const content = this.cacheDataPopin[dataCode];

        if ($('.popinSurroundings-fancybox').length) {
          $('.fancybox-slide').html(content);
          $('.popinSurroundings').append('<button data-fancybox-close class="fancybox-close-small" title="Close" />');
        } else {
          window.fancybox.open(content, fancyboxOptions);
        }

        if ($('.popinSurroundings .js-sliderPhotos').length) {
          sliderPhotosModule().then(({sliderPhotos}) => {
            $('.popinSurroundings .js-sliderPhotos').data('directrender', true);
            sliderPhotos.initialize();
          });
        }

        if ($('.popinSurroundings .js-fancybox-video').length) {
          new FancyboxView({
            selector: '.js-fancybox-video',
            fancyType: 'custom',
            allowDoubleFancy: true,
            options: {
              buttons: ['close'],
              overlayClose: false,
              isModal: false,
              preventScroll: true,
              clickSlide: false,
              clickOutside: false,
              touch: true,
              loop: true,
              baseClass: 'fancybox-skin--white fancybox-skin--white_slide-in-top'
            }
          });

          $('.popinSurroundings-video.js-fancybox-video').on('click', () => {
            Tracking.dataLayerPush({
              event: 'clickEvent',
              clickCode: 'ClickSurroundingsDetails',
              gaCategory: PAGE_SCRIPTS.page_template,
              gaAction: 'SurroundingsDetails',
              gaLabel: 'videos play'
            });
          });
        }

        if (DEVICE.isMobile) {
          $('.popinSurroundings').off('scroll').on('scroll', () => {
            this.setStickyCloseBtn();
          });
        }

        genericToggle.init('.popinSurroundings .api_toggle');
        button.clearButtonLoader();
      };

      if (Object.keys(this.cacheDataPopin).length === 0) {
        genericAjaxCall({
          ajaxUrl: `${GLOBAL_SCRIPTS.URL_API_POI}list/${PRODUCT_SCRIPTS.PRODUCT_CODE}/${PRODUCT_SCRIPTS.SEASON_CODE}/${GLOBAL_SCRIPTS.LANGUAGE_CODE}?sort=distance`,
          ajaxParams: {},
          successCallback: (result) => {
            PRODUCT_SCRIPTS.POI_DATA = result.data.poi;
            result.data.prevActivite = dataPrevCode;
            result.data.nextActivite = dataNextCode;

            result.data.poi.forEach((poi, index) => {
              const prevPoiCode = index > 0 ? result.data.poi[index - 1].ownerCode : null;
              const nextPoiCode = index < result.data.poi.length - 1 ? result.data.poi[index + 1].ownerCode : null;

              this.cacheDataPopin[poi.ownerCode] = popinSurroundingsTpl({
                poiData: poi,
                prevPoiData: prevPoiCode,
                nextPoiData: nextPoiCode,
                wordings: WORDINGS_FANCYBOX_JSON,
                urlBase: GLOBAL_SCRIPTS.STATIC_VERSION
              });
            });
            successCallback();
          },
          abortable: true,
          origin: 'popinSurroundings',
          dataType: 'json',
          type: 'GET'
        });
      } else {
        successCallback();
      }

      if (DEVICE.isDesktop && !$('.mapPOI').hasClass('closed')) {
        dispatcher.trigger('poi:gmap:goToMarker', dataCode);
      }

      const originEvent = $(event.currentTarget).data('origin');

      Tracking.dataLayerPush({
        event: 'clickEvent',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: originEvent === 'gmap' ? 'POI mini tile' : 'POI list',
        gaLabel: originEvent === 'gmap' ? 'Click button learn more' : 'Click POI'
      });
    });

    this.copyRegionAddress();

    $(document).on('click', '.js-poiItinerary', (e) => {
      Tracking.dataLayerPush({
        event: 'clickEvent',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'POI tile',
        gaLabel: 'Click button directions'
      });
    });
  },

  copyRegionAddress: function () {
    $(document).on('click', '.js-copyClipboard', (e) => {
      const regionText = $('.popinSurroundings-region').text();
      navigator.clipboard.writeText(regionText);

      $('.popinSurroundings-copy').addClass('tooltip-active');

      setTimeout(() => {
        $('.popinSurroundings-copy').removeClass('tooltip-active');
      }, 1500);
    });
  },

  setStickyCloseBtn: function () {
    const initialTop = $('.popinSurroundings-visuals').offset().top - $(window).scrollTop();

    if (initialTop <= 30) {
      $('.fancybox-close-small').addClass('is-sticky');
    } else {
      $('.fancybox-close-small').removeClass('is-sticky');
    }
  }
};